import { store } from "../store";

export const setLocale = (payload) => {
  return async (dispatch) => {
    await dispatch({
      type: "SET_LOCALE",
      payload,
    });
  };
};

export const getLocale = () => {
  return {
    type: "GET_LOCALE",
    payload: store.getState(),
  };
};
